
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Previewer from 'vux/src/components/previewer/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'

import VuePreview from 'vue-preview'
import photoImg from '@/assets/plus.png'
import deleteImg from '@/assets/img/delete.png'
export default {
directives: {
TransferDom
},
components: {
Previewer,
Actionsheet
},
props: {
title: {
type: String,
default: ''
},
is_upload: {
type: Boolean,
default: true
},
files: {
type: Array,
default: function() {
return []
}
},
limit: {
type: Number,
default: 0
},
size: {
type: Number,
default: 20 // 单位M，图片最大size
},
upLoadUrl: {
type: String,
default: 'fileUp.ashx?action=UploadOBS'
},
view_type: {
type: String,
default: 'grid' // cell,grid
},
params: {
type: Object,
default: function() {
return {}
}
},
file_type: {
type: String,
default: 'image/gif,image/jpeg,image/jpg,image/png,image/svg,image/heic'
}
},
computed: {
imgs() {
return this.files;
},
prj_code() {
return this.$store.state.app.prj_code
},
uploadAction() {
const code = this.prj_code
if (code === 'Asus' || code === 'Acer') {
return this.upLoadUrl
}
return 'fileUp.ashx?action=Upload'
}
},
data() {
let _this = this;
return {
uploadOpen: false,
uploadMenu: {
menu1: '拍照',
menu2: '选择照片'
},
is_upload_class: this.is_upload ? '' : 'upload-disabled',
view_class: this.view_type == 'cell' ? 'cell-upload-plugin' : 'grid-upload-plugin',
photoImg: photoImg,
deleteImg: deleteImg,
headerMsg: {},
multiple: this.limit == 1 ? false : true,
options: { //需正确配置
getThumbBoundsFn(index) {
let thumbnail = _this.$refs.uploadDiv.querySelectorAll('.el-upload-list__item-thumbnail')[index];
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
let rect = thumbnail.getBoundingClientRect()
return {
x: rect.left,
y: rect.top + pageYScroll,
w: rect.width
}
},
isClickableElement: function(el) {
return /previewer-delete-icon/.test(el.className)
}
}
}
},
methods: {
isIos() {
if (navigator.userAgent.indexOf('iPhone') != -1 || navigator.userAgent.indexOf('iPad') != -1) return true
return false
},
openChoice() {
if (this.isIos()) this.$refs.filElem1.dispatchEvent(new MouseEvent('click'))
else this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
},
choiceFile(key, item) {
if (this.limit > 0 && this.files.length >= this.limit) {
this.$toast.text('最多上传' + this.limit + '张图片')
return
}
if (key == 'menu1') this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
else if (key == 'menu2') this.$refs.filElem1.dispatchEvent(new MouseEvent('click'))
},
onChange(elem) {
let that = this;
const inputFile = this.$refs[elem].files[0];
if (!inputFile) return
if (!this.onBeforeUpload(inputFile)) return
const reader = new FileReader();
reader.readAsDataURL(inputFile);
reader.onload = function(e) {
inputFile.msrc = this.result;
that.files.push(inputFile)
}
this.upload(inputFile);
},
onBeforeUpload(file) {
let _this = this;

const isImage = file.type.indexOf('image') !== -1;

const isLimitSize = file.size / 1024 / 1024 < _this.size;
if (!isImage) {
this.$message.error('上传文件必须是图片!');
return false;
}
if (!isLimitSize) {
this.$message.error('上传文件大小不能超过 ' + _this.size + 'MB!');
return false;
}
return true;
},
upload(file) {
let _this = this
var reader = new FileReader();
reader.readAsDataURL(file);
reader.onload = function(e) {
var img = new Image();
img.src = this.result;
img.onload = function() {
file.w = img.width
file.h = img.height
file.src = img.src
file.msrc = img.src
let blob = _this.dataURItoBlob(_this.compress(img));
let param = new FormData(); 
param.append('file', blob); 
param.append("filename", file.name)
var tmpArr = file.name.split('.');
param.append("FileType", tmpArr[tmpArr.length - 1])

for (var k in _this.params) {
param.append(k, _this.params[k])
}
_this.toUpload(file, param)
}
}
},
toUpload(file, param) {
let _this = this
let config = {
login: false,
headers: {
'content-type': 'multipart/form-data'
},
onUploadProgress: progressEvent => {
var complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
file.progress = complete
_this.$set(_this.files, _this.files.indexOf(file), file)
}
}; //添加请求头
this.$post(this.uploadAction, param, config)
.then(response => {
_this.onSuccess({
Code: 1,
Data: response
}, file);
}).catch(err => {
console.log('upload err', err)
_this.files.splice(_this.files.indexOf(file), 1)
});
},
onPreview(file) {
let index = this.imgs.indexOf(file)
this.$refs.previewer.show(index);
},
onExceed(files) {



if (files.length + this.files.length > this.limit) {
this.$toast.text('最多只能上传' + this.limit + '个文件')
}
},
onSuccess(res, file) {
if (res.Code == 1) {
let _this = this
file.URL = res.Data
if (res.Data.indexOf('http') == -1) {
file.src = res.Data.indexOf('http') != -1 ? res.Data : _this.$store.getters.getFileRoot + res.Data
} else {
file.src = res.Data
}
_this.$set(_this.files, _this.files.indexOf(file), file)
_this.$emit('onSuccess', _this.files)
return true
} else {
this.$toast.text(res.Msg || '上传失败')
return false
}
},
removeImg() {
let index = this.$refs.previewer.getCurrentIndex();
this.$refs.previewer.close()
this.files.splice(index, 1)
this.$emit('onSuccess', this.files)
},

compress(img) {
let canvas = document.createElement("canvas");
let ctx = canvas.getContext("2d");
let initSize = img.src.length;
let width = img.width;
let height = img.height;
canvas.width = width;
canvas.height = height;

ctx.fillStyle = "#fff";
ctx.fillRect(0, 0, canvas.width, canvas.height);
ctx.drawImage(img, 0, 0, width, height);


let ndata = canvas.toDataURL("image/jpeg", 0.3333);



return ndata;
},

dataURItoBlob(base64Data) {
var byteString;
if (base64Data.split(",")[0].indexOf("base64") >= 0)
byteString = atob(base64Data.split(",")[1]);
else byteString = unescape(base64Data.split(",")[1]);
var mimeString = base64Data
.split(",")[0]
.split(":")[1]
.split(";")[0];
var ia = new Uint8Array(byteString.length);
for (var i = 0; i < byteString.length; i++) {
ia[i] = byteString.charCodeAt(i);
}
return new Blob([ia], {
type: mimeString
});
}
},
}



// WEBPACK FOOTER //
// ./src/components/UploadImage.vue